import { useParams } from "react-router-dom";
import { SessionDTO } from "../dtos/SessionDTO"
import Session from "./SessionTeaser"

export default function Sessions(props: {
  sessions: SessionDTO[]
}) {
  const { sessionKey } = useParams();
  return (
    <div
      className='flex flex-gap flex-wrap'
    >
      {
        props.sessions.map(session => {
          return <Session
            key={`session-${session.session_key}`}
            session={session}
            active={session.session_key === parseInt(sessionKey || '', 10)}
          />
        })
      }
    </div>
  )
}